import { z } from "zod";

export const NewbornPostpartumPhysicalExamSectionSchema = z.object({
  normal: z.boolean(),
  notNormal: z.boolean(),
  declined: z.boolean(),
  normalDetails: z.array(z.string()),
  notNormalDetails: z.array(z.string()),
  notes: z.string(),
});

export const NewbornPostpartumPhysicalExamSchema = z.object({
  sections: z.record(z.string(), NewbornPostpartumPhysicalExamSectionSchema),
  notes: z.string(),
});

export type NewbornPostpartumPhysicalExam = z.infer<typeof NewbornPostpartumPhysicalExamSchema>;

export type NewbornPostpartumPhysicalExamSection = z.infer<
  typeof NewbornPostpartumPhysicalExamSchema
>;
export type NewbornPostpartumPhysicalExamSectionField = z.infer<
  typeof NewbornPostpartumPhysicalExamSchema
>;
